// transfers
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { saveAs } from 'file-saver';

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import FormNeeded from "../webb/form-needed";
import WebbSpinner from "../webb/webb-spinner-sm";
import ListNoData from "../webb/list-nodata";

import { GetEventsInfo, NewTicketSales } from "../../services/srvc-events-realm";
import { CreateNFTStore } from "../../services/srvc-store-filecoin";
import { XTokenMint, XGetClassicAddress } from "../../services/srvc-tokens-xr";

export default function EventsViewWWModule() {

  const asset = {usid: 'ww'}

  const {id} = useParams()
  const [loading, setLoading] = useState(true);
  
  const [form, setForm] = useState(false);
  const [tick, setTicket] = useState(false);
  const [sale, setSale] = useState(false);
  
  const [linx, setLinkStatus] = useState(false);
  const [link, setLink] = useState('');

  const [mint, setMintStatus] = useState(false);
  const [acnt, setAccount] = useState('');

  const [info, setInfo] = useState({});
  const [data, setData] = useState({
    name: '',
    emid: '',
    acnt: '',
    scrt: '',
    nmbr: '24' + Date.now().toString() + '6',
    link: '',
    cidx: ''
  })

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
       const datx = await GetEventsInfo({
         data: {enid: id},
         user: asset.usid
       })
       setInfo(datx.data)
      setLoading(false)
      }
      fetchData()
    } else {}
  },[asset.usid, id]);

  // useEffect for form validation
  useEffect( () => {
    setForm(false);
    if (data.name!=='' && data.emid!=='' && data.scrt!=='') 
      setForm(true);
  },[data]);


  const CreateTokenLink = async () => {
    
    const adrs = await XGetClassicAddress(data.scrt)
    setAccount(adrs)

    var token = {
      name: info.name,
      memo: info.memo,
      wise: data.nmbr,
      link: info.link,
      form: info.form,
      sort: info.sort,
      dist: 'xrpl',
      stts: (new Date(info.stts)).toISOString(),
      ents: (new Date(info.stts)).toISOString(),
      user: data.name,
      usid: data.emid,
      usac: adrs,
      issr: info.issr,
      isid: info.isid,
      isac: info.isac,
    }
    console.log(token)
    var blob = new Blob([JSON.stringify(token)], {type: "application/json;charset=utf-8"});
    //saveAs(blob, `${data.nmbr}.json`);

    const res = await CreateNFTStore(blob)
    // console.log (res)
    handleChange('cidx', res.cidx)
    setLink(res.urla)
    setLinkStatus(true)

    return res.cidx
  }

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async () => {

    if (form) {
      setSale(true)
      const cids = await CreateTokenLink()
      console.log (cids)
      const tokenmint = await XTokenMint({
        scrt: data.scrt,
        link: 'ipfs://'+cids
      })

      console.log(tokenmint)
      if (tokenmint) {
        setMintStatus(true);
        const result = await NewTicketSales({
          data: {
            name: data.name, 
            emid: data.emid,
            acnt: await XGetClassicAddress(data.scrt), 
            nmbr: data.nmbr,
            link: link, 
            enid: id, tkid: 
            tokenmint.tkid
          },
          user: 'ww'
        })
      }
      else {
        alert('Error: Please try again')
        setSale(false)
      }
      
    }
    else alert('Please enter all details')

  }


  if (loading){ return ( <> <div className="text-center"><WebbSpinner /></div> </> ) }

  return (
  <>
    {/* {console.log (info)} */}
    <div className="media-square">
      <img src={info.link} className='img-fluid rounded-wd' alt="..."></img>
    </div>

    <WebbDividerSmall />
    <div className="p-3 bg-white rounded-wd">
      <p className="small fw-bold text-color-tone mb-2">Date: {info.stts}</p>
      <h2 className="fw-bold lead text-color-main">{info.name}</h2>
      <p className="m-0">{info.memo}</p>
    </div>

    <WebbDividerSmall />
    <div className="p-3 bg-white rounded-wd">
      
      <div className="d-flex">
        <p className="m-0 me-auto">
          <i className="bi-gift pe-2"></i>
          {info.tick} POAPs Minted
        </p>
        <p className="m-0">XRP {info.cost}</p>
      </div>
      {/* ticket sales progress */}


      <WebbDividerSmall />
      <div className={`text-color-main ${tick? 'd-none': ''}`}
        style={{'cursor':'pointer'}}
        onClick= {()=> setTicket(true)}
      >
        Claim POAP
      </div>
    </div>

    <WebbDividerSmall />
    <div className={`p-3 bg-white rounded-wd ${tick? '': 'd-none'}`}>

      <div className={`form-group mb-3`}>
        <label className="form-label small">Name  <FormNeeded /></label>
        <input type="text" 
          className="form-control height-md" 
          style={{fontSize:'0.9rem', height:'2.7rem'}}
          value={data.name}
          onChange={({ target }) => {handleChange("name", target.value);}}
          placeholder="Alice Wonderland">
        </input>
      </div>

      <div className={`form-group mb-3`}>
        <label className="form-label small">Email  <FormNeeded /></label>
        <input type="text" 
          className="form-control height-md" 
          style={{fontSize:'0.9rem', height:'2.7rem'}}
          value={data.emid}
          onChange={({ target }) => {handleChange("emid", target.value);}}
          placeholder="user@mail.com">
        </input>
      </div>

      <div className={`form-group mb-3`}>
        <label className="form-label small">XRPL Secret  <FormNeeded /></label>
        <input type="password" 
          className="form-control height-md" 
          style={{fontSize:'0.9rem', height:'2.7rem'}}
          value={data.scrt}
          onChange={({ target }) => {handleChange("scrt", target.value);}}
          placeholder="rVVW3Bq1JmqbJVaYppjE8f6Si2osc3Jx2">
        </input>  
        <p className="small mt-2">
          Note: This only works with NFT-Devnet Accounts.
          Please get one at 
          <a href='https://xrpl.org/xrp-testnet-faucet.html' 
            target={'_blank'} className='ms-2 fw-bold'
            >NFT Devnet Credentials 
          </a>
        </p>
        <label className="form-label small">
          Your keys are required for processing this on your device. 
          The keys are not transfered or stored in our systems.
        </label>
        <label className="form-label small">
          XUMM Integration Coming Soon.
        </label>
      </div>

      <WebbDividerSmall />
      <div className="d-flex justify-content-between">

        <div className="">
          <button className="btn btn-sm btn-outline-secondary border rounded-pill px-3"
          onClick={()=> setTicket(false)}
          ><small>Cancel</small></button>
        </div>

        <div className="">
          <button className="btn btn-sm btn-primary rounded-pill px-3"
          disabled={!form}
          onClick={()=> handleSubmit()}
          ><small>Claim POAP</small></button>
        </div>

      </div>


    </div>

    <WebbDividerSmall />
    <div className={`p-3 bg-white rounded-wd text-center ${tick && sale? '': 'd-none'}`}>
      
      <div className="text-center mb-3">
        <i className={linx && mint 
          ? 'bi-gift text-success caption-md' 
          : 'bi-grig text-color-tone caption-md' 
        }></i>

        
      </div>

      <div className="d-flex mb-2">
        <div className="">
          Curate Token - {linx ? 'Done' : 'Please Wait...'}
        </div>
        <div className="ms-auto">
          <i className={linx 
            ? 'bi-check-circle-fill text-success' 
            : 'bi-exclamation-circle-fill text-warning'
          }></i>
        </div>

      </div>

      <div className="d-flex mb-2">
        <div className="me-auto">
          Minting Your POAP - {mint ? 'Done' : 'Please Wait...'}
        </div>
        <div className="">
          <i className={mint ? 'bi-check-circle-fill text-success' : 'bi-exclamation-circle-fill text-warning'}></i>
        </div>

      </div>
      
      <WebbDividerSmall/>
      <div className={`text-center mb-3 ${mint ? 'd-none' : ''}`}>
        <WebbSpinner/>
      </div>

    </div>


    <WebbDividerSmall />
    <div className={`p-3 bg-white rounded-wd ${tick && sale && mint ? '': 'd-none'}`}>
      Visit Your XR Token Page <Link to={`/u/${acnt}`} target={'_blank'}>Here</Link>
    </div>

    <WebbDividerMedium />
    <WebbDividerMedium />
    <WebbDividerMedium />
  </>
  )
}